import React, { useEffect, useState, useContext } from 'react';
import './Components.css';
import { GetNextShotNumberFromSetup, GetSetupDescription } from '../isdlData/sessionData';
import { Cross2Icon } from '../icons/Icons';

function MoveShot({CurrentSession, CurrentSetup, CurrentShot, MoveShotResult}){

    const [valid, setValid] = useState(false);
    const [setups, setSetups] = useState([]);
    const [selectedSetup, setSelectedSetup] = useState(null);
    const [newShotNumber, setNewShotNumber] = useState('0');

    useEffect(() => {
        setSelectedSetup(CurrentSetup.Id);
        setSetups(CurrentSession.SessionSetups.map(setup => ({Id: setup.Id, Name: GetSetupDescription(setup), Letter: setup.LetterId ?? ''})));
    },[]);

    const clickResult = (result) => {
        if(valid){
            MoveShotResult({result:result, newSetup: selectedSetup});
        }else{
            MoveShotResult({result:result});
        }
    };

    const handleSetupChange = (e) => {
        const selection = e.target.value;

        setSelectedSetup(selection);
        setNewShotNumber(GetNextShotNumberFromSetup(CurrentSession.SessionSetups.find(setup => setup.Id === selection)));
        setValid(true);
    }

    return(
        <div className='modal-container' style={{height:"275px", maxWidth:"400px"}}>
            <button className='modal-close-button' onClick={() => clickResult(false)}><Cross2Icon width='30px' height='30px'/></button>
            <div className='modal-header'>Move Shot</div>
            <div className='modal-content'>
                <span style={{marginBottom:'5px'}}>You are attempting to move shot <b>#{CurrentShot.ShotNumber}</b></span>
                <span style={{marginBottom:'5px'}}>to setup:</span>
                <select 
                value={selectedSetup} 
                onChange={handleSetupChange} 
                style={{height:'40px', width:'100%'}}>
                    {setups.map((setup) => (
                    <option key={setup.Id} value={setup.Id} disabled={setup.Id === CurrentSetup.Id}>
                        
                        {setup.Letter && setup.Letter !== '' ? `${setup.Letter}:  ${setup.Name}` : setup.Name}
                    </option>
                    ))}
                </select>
                {selectedSetup !== CurrentSetup.Id ? (
                    <span>The new shot number will be <b>#{newShotNumber}</b></span>
                ) : (<div style={{height:'20px'}}></div>)}
            </div>
            <div className="modal-footer" >
                <button className="button" disabled={!valid} style={{width:'100px'}} onClick={() => clickResult(true)}>Move</button>
            </div>
        </div>
            );
}

export default MoveShot;